module.exports = require("./es-US.d.ts");